import { layerDepthDiff, BOARD_SIZE } from "../constants";

export function addFloor({
  x,
  y,
  scene,
  random,
  chunkNumber,
}: {
  x: number;
  y: number;
  scene: Phaser.Scene;
  random: Phaser.Math.RandomDataGenerator;
  chunkNumber: number;
}): void {
  if (chunkNumber === 1) {
    const sprite_bottom = scene.add.sprite(
      x * BOARD_SIZE,
      (y + 1) * BOARD_SIZE,
      "atlas",
      `building_walls/wall_strip_chunk1`
    );
    sprite_bottom.setActive(false);
    sprite_bottom.setDepth(y + layerDepthDiff.FLOOR - 0.1);
    return;
  } else if (chunkNumber === 2) {
    const sprite_bottom = scene.add.sprite(
      x * BOARD_SIZE,
      (y + 1) * BOARD_SIZE - 2,
      "atlas",
      `building_walls/wall_strip_chunk2_${random.integerInRange(1, 10)}`
    );
    sprite_bottom.setActive(false);
    sprite_bottom.setDepth(y + layerDepthDiff.FLOOR - 0.1);
  } else if (chunkNumber === 3) {
    const sprite_bottom = scene.add.sprite(
      x * BOARD_SIZE,
      (y + 1) * BOARD_SIZE - 2,
      "atlas",
      `building_walls/wall_strip_chunk3_${random.integerInRange(1, 10)}`
    );
    sprite_bottom.setActive(false);
    sprite_bottom.setDepth(y + layerDepthDiff.FLOOR - 0.1);
    sprite_bottom.setTint(0xcccccc);
  } else if (chunkNumber === 4) {
    const sprite_bottom = scene.add.sprite(
      x * BOARD_SIZE,
      (y + 1) * BOARD_SIZE - 2,
      "atlas",
      `building_walls/wall_strip_chunk4_${random.integerInRange(1, 10)}`
    );
    sprite_bottom.setActive(false);
    sprite_bottom.setDepth(y + layerDepthDiff.FLOOR - 0.1);
    sprite_bottom.setTint(0x99bbdd);
  } else if (chunkNumber === 5 || chunkNumber === 6) {
    const sprite_bottom = scene.add.sprite(
      x * BOARD_SIZE,
      (y + 1) * BOARD_SIZE - 2,
      "atlas",
      `building_walls/wall_strip_chunk5_${random.integerInRange(1, 10)}`
    );
    if (random.frac() > 0.5) {
      sprite_bottom.setFlipX(true);
      sprite_bottom.x += 8;
    }
    sprite_bottom.setActive(false);
    sprite_bottom.setDepth(y + layerDepthDiff.FLOOR - 0.1);

    if (chunkNumber === 6) {
      sprite_bottom.setTint(0x888888);
    }
  } else {
    const sprite_bottom = scene.add.sprite(
      x * BOARD_SIZE,
      y * BOARD_SIZE,
      "atlas",
      `building_walls/front_wall_strip`
    );
    sprite_bottom.setActive(false);
    sprite_bottom.setDepth(y + layerDepthDiff.FLOOR - 0.1);
  }
}
